var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-configurator-main", attrs: { id: "cd-configurator" } },
    [
      _c(
        "b-container",
        { staticClass: "cd-configurator-container" },
        [
          _c(
            "b-container",
            { staticClass: "stepper" },
            [
              _c("Stepper", {
                attrs: {
                  steps: _vm.maxProgress,
                  currentStep: _vm.currentProgress
                }
              })
            ],
            1
          ),
          _c(
            "b-container",
            { staticClass: "header" },
            [
              _c(
                "b-row",
                {},
                [
                  _c(
                    "b-col",
                    { attrs: { cols: _vm.isCompactLayout ? 10 : 12 } },
                    [
                      _c("div", { staticClass: "cd-progress" }, [
                        _vm._v(" " + _vm._s(_vm.progress) + " ")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: " d-header-section" },
                [
                  _c("b-col", { staticClass: "pt-0 col-12 col-md-10" }, [
                    _c("h3", { staticClass: "h3 font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.progressSubline) + " ")
                    ])
                  ]),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "col-12 col-md-2 p-0 m-0 d-flex justify-content-end"
                    },
                    [
                      _c("div", { staticClass: "d-none d-md-block" }, [
                        _c(
                          "p",
                          { staticClass: "cd-max-progress cd-primary-color" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.currentProgress) +
                                " / " +
                                _vm._s(_vm.maxProgress) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("hr"),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _vm.currentProgress < 7
                      ? _c("div", { staticClass: "cd-selection-text" }, [
                          _c(
                            "span",
                            { staticClass: "cd-current-selectiontext" },
                            [_vm._v(_vm._s(_vm.currentSelection))]
                          )
                        ])
                      : _vm._e(),
                    _vm.showEquipmentCompairsionLink
                      ? _c(
                          "div",
                          { staticClass: "cd-equipment-compairsion-link" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "cd-primary-color",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openEquipmentCompairsion()
                                  }
                                }
                              },
                              [_vm._v("Vergleichen")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c("b-col", [
                    _vm.stock.length > 0
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn cd-button cd-std-button cd-next-button btn-secondary btn-sm",
                            attrs: { type: "button" },
                            on: { click: _vm.showStockModal }
                          },
                          [_vm._v("Vorätige Fahrzeuge")]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("b-modal", {
            attrs: {
              static: "",
              scrollable: "",
              id: "cd-stock-modal",
              size: "lg",
              title: "Fahrzeuge im Bestand"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  return [
                    _c(
                      "b-container",
                      {},
                      _vm._l(_vm.stock, function(stockItem, stockIndex) {
                        return _c(
                          "b-card",
                          {
                            key: stockIndex,
                            staticClass: "mb-1",
                            attrs: { "no-body": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "footer",
                                  fn: function() {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn cd-button cd-std-button cd-next-button btn-secondary btn-sm",
                                          attrs: {
                                            href: stockItem.detail_url,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("Zum Angebot")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "b-card-header",
                              {
                                staticClass: "p-1",
                                attrs: { "header-tag": "header" }
                              },
                              [_c("h5", [_vm._v(_vm._s(stockItem.title))])]
                            ),
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c("b-img", {
                                          staticClass: "w-100",
                                          attrs: { src: stockItem.thumbnail }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("b-col", [
                                      _c("p", [
                                        _c("b", [_vm._v("Marke:")]),
                                        _vm._v(" " + _vm._s(stockItem.make)),
                                        _c("br"),
                                        _c("b", [_vm._v("Modell:")]),
                                        _vm._v(" " + _vm._s(stockItem.model)),
                                        _c("br"),
                                        _c("b", [_vm._v("Verfügbarkeit:")]),
                                        _vm._v(
                                          " " + _vm._s(stockItem.availability)
                                        ),
                                        _c("br"),
                                        _c("b", [_vm._v("Kraftstoff:")]),
                                        _vm._v(
                                          " " + _vm._s(stockItem.fuel_type)
                                        ),
                                        _c("br"),
                                        _c("b", [
                                          _vm._v("Kraftstoffverbrauch:")
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getConsumption(stockItem)
                                            )
                                        ),
                                        _c("br"),
                                        _c("b", [_vm._v("Co²-Klasse:")]),
                                        _vm._v(
                                          " " + _vm._s(stockItem.co2_class)
                                        ),
                                        _c("br"),
                                        _c("b", [_vm._v("Co²-Emission:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(stockItem.co2_emissions) +
                                            " g/km"
                                        ),
                                        _c("br"),
                                        _c("b", [_vm._v("Kilometerstand:")]),
                                        _vm._v(" " + _vm._s(stockItem.mileage)),
                                        _c("br"),
                                        _c("b", [_vm._v("Preis:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                stockItem.total_price_gross
                                              )
                                            ) +
                                            " €"
                                        ),
                                        _c("br")
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ]
                }
              },
              {
                key: "modal-footer",
                fn: function(ref) {
                  var ok = ref.ok
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "cd-button",
                        attrs: { size: "sm" },
                        on: {
                          click: function($event) {
                            return ok()
                          }
                        }
                      },
                      [_vm._v("Schliessen")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("Loader"),
          _vm.isCompactLayout ? _c("Sidebar") : _vm._e(),
          _vm.showCarInfo
            ? _c(
                "b-container",
                { attrs: { fluid: "", classs: "cd-car-info" } },
                [_c("CarInfo")],
                1
              )
            : _vm._e(),
          _c(
            "b-container",
            { staticClass: "cd-application-frame", attrs: { fluid: "" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }